import { useEffect, useState } from 'react'
import { decodeWithFourbyte, type DecodedCall } from '../lib/fourbyte.js'

/**
 * Resolves a calldata payload against the OpenChain signature DB. Returns
 * `null` while loading or if the selector is unknown. Hits a localStorage
 * cache, so the same calldata across re-renders is instant after first hit.
 */
export function useDecoded4byte(data: string | undefined): DecodedCall | null {
  const [decoded, setDecoded] = useState<DecodedCall | null>(null)
  useEffect(() => {
    if (!data || !data.startsWith('0x') || data.length < 10) {
      setDecoded(null)
      return
    }
    let cancelled = false
    setDecoded(null)
    void decodeWithFourbyte(data).then((d) => {
      if (!cancelled) setDecoded(d)
    })
    return () => {
      cancelled = true
    }
  }, [data])
  return decoded
}
